import { render } from "./SZargur.vue?vue&type=template&id=647035d8&scoped=true"
import script from "./SZargur.vue?vue&type=script&lang=js"
export * from "./SZargur.vue?vue&type=script&lang=js"

import "./SZargur.vue?vue&type=style&index=0&id=647035d8&lang=scss&scoped=true"
import "./SZargur.vue?vue&type=style&index=1&id=647035d8&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-647035d8"]])

export default __exports__